export default {
  'forms.save_status_checks.authentication.authentication_url_aws.prompt':
    'What endpoint should we test your credentials against?',
  'forms.save_status_checks.authentication.aws.add_new_account.text_field.label':
    'Add a new account ID',
  'forms.save_status_checks.authentication.aws.aws_account_id.text_field.label':
    'AWS Account ID',
  'forms.save_status_check.select_observability_tool_and_domain.domain.select_field.label':
    'Domain',
  'forms.save_status_checks.custom_observability_tool_options.observability_tool_name.prompt':
    'In the future, what name should your team see as the name of this observability tool definition?',
  'forms.save_status_checks.custom_observability_tool_options.observability_tool_name.text_field.label':
    'Observability Tool Nickname',
  'forms.save_status_checks.custom_observability_tool_options.multiple_regions.prompt':
    'Does this observability tool have multiple regions?',
  'forms.save_status_checks.custom_observability_tool_options.multiple_regions.custom_domain_name.text_field.label':
    'Domain Name',
  'forms.save_status_checks.custom_observability_tool_options.is_private_network.prompt':
    'Is this observability tool behind a firewall or on-prem?',
  'forms.save_status_checks.custom_observability_tool_options.is_private_network.alert.line_1.text':
    'You will need to install a ',
  'forms.save_status_checks.custom_observability_tool_options.is_private_network.alert.link.text':
    'private network integration agent',
  'forms.save_status_checks.custom_observability_tool_options.is_private_network.alert.error.text':
    'There was an error when checking for a'
}
